import * as yup from 'yup';

export const VALIDATION_SCHEMA = yup.object().shape({
  value: yup.string().required('Obbligatorio'),
  color: yup.string().required('Obbligatorio').matches(/^#/, 'Il modello dovrebbe iniziare da #')
});
